import React from "react";
import { Button, classnames, Icon } from "@culturehq/components";
import { Template } from "chq";

import { Trans } from "app/utils";
import ChqModalConfirm from "components/common/ChqModalConfirm";
import { ElementState, Preview } from "@creatomate/preview";
import { GENERIC_ELEMENT } from "components/stories/video-studio/utils/constants";
import getMediaElements from "components/stories/video-studio/utils/creatomate/getMediaElements";

interface CardProps {
  template: Template;
  onSelectedTemplate: (template: Template) => void;
  onTrigger: () => void;
  templateLibrary?: boolean;
  preview?: Preview;
}

const Card: React.FC<CardProps> = ({
  template,
  onSelectedTemplate,
  onTrigger,
  preview
}) => {
  const { elements } = preview?.getSource() || {};
  const allMediaElements = getMediaElements("video", preview)?.filter(media => !media.source.name.includes(GENERIC_ELEMENT.INTRO));
  const firstMediaElement = allMediaElements ? allMediaElements[0] : undefined;
  const elementsToBeDeleted = firstMediaElement ? elements?.filter((element: ElementState) => (
    element.track !== firstMediaElement.source.track
  )) : [];

  const message = "Are you sure you want to select this template? We'll only keep the photo and video elements in the story's primary track; all other elements will be lost.";
  const displayConfirm = elementsToBeDeleted ? elementsToBeDeleted.length > 0 : false;

  return (
    <div
      className={classnames("PhotoGroup__thumbnail", "Story", "Template")}
      onClick={onTrigger}
      role="button"
      style={{ backgroundImage: `url(${template.posterUrl})` }}
      tabIndex={0}
    >
      <div className="Story__information--profile">
        <div className="background-container">
          <div className="Story__creator">
            <div>
              <h4 className="Template-Title">{template.name}</h4>
              <p>{template.description}</p>
            </div>
          </div>
          <Icon className="play-icon" icon="play-no-border" />
        </div>
      </div>
      <div className="Story__information--profile Story__answer">
        <div className="background-container">
          <div
            className="footer"
            onClick={(event?: React.MouseEvent<HTMLDivElement>) => {
              if (event) event.stopPropagation();
            }}
          >
            {!displayConfirm && (
              <Button
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  event.stopPropagation();
                  onSelectedTemplate(template);
                }}
              >
                <><Icon icon="ios-plus" /><Trans>Select Template</Trans></>
              </Button>
            )}
            {displayConfirm && (
              <ChqModalConfirm
                onAccept={(event?: React.MouseEvent<HTMLButtonElement>) => {
                  if (event) event.stopPropagation();
                  onSelectedTemplate(template);
                }}
                trigger={(onTrigger: () => void) => (
                  <Button
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                      event.stopPropagation();
                      onTrigger();
                    }}
                  >
                    <><Icon icon="ios-plus" /><Trans>Select Template</Trans></>
                  </Button>
                )}
              >
                <Trans>
                  {message}
                </Trans>
              </ChqModalConfirm>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
